import { httpClient } from "./httpClient";

const getAllImpact = () => {
  return httpClient.get("impacts");
};

export default {
  getAllImpact,
};
